import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';
export const getAllSignatureList = () => {
  return api.get(URLS.signatureList, {
    headers: {
      needsToken: true
    }
  });
};

export const getDefaultSignature = () => {
  return api.get(URLS.signatureDefaults, {
    headers: {
      needsToken: true
    }
  });
};

export const updateDefaultSignature = (defaultSignatureData) => {
  return api.post(URLS.signatureDefaults, defaultSignatureData, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteSignature = (signatureID) => {
  return api.delete(URLS.signature, {
    params: {
      id: signatureID
    },
    headers: {
      needsToken: true
    }
  });
};

export const saveSignature = (signatureData) => {
  return api.post(URLS.signature, signatureData, {
    headers: {
      needsToken: true
    }
  });
};

export const signatureDetails = (signatureID) => {
  return api.get(URLS.signature, {
    params: {
      id: signatureID
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateSignature = (signatureID, signatureData) => {
  return api.put(URLS.signature, signatureData, {
    params: {
      id: signatureID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getMyFilledSignature = (type) => {
  return api.get(URLS.signatureFilled, {
    params: {
      type: type
    },
    headers: {
      needsToken: true
    }
  });
};
